import { render, staticRenderFns } from "./swiperVideo.vue?vue&type=template&id=7051166e&scoped=true&"
import script from "./swiperVideo.vue?vue&type=script&lang=js&"
export * from "./swiperVideo.vue?vue&type=script&lang=js&"
import style0 from "./swiperVideo.vue?vue&type=style&index=0&id=7051166e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051166e",
  null
  
)

export default component.exports